export const isData = (value) => {
  return value || "-";
};

export const mask = (text, [startMasking, endMasking]) => {
  if (!text) {
    return "-";
  }
  return `${text.slice(0, startMasking)}XXXXX${text.slice(endMasking)}`;
};

export const maskPan = (text, [startMasking, endMasking]) => {
  if (!text) {
    return "-";
  }
  return mask(text, [startMasking, endMasking]);
};

export const splitDate = (value, separator="T") => {
  if (!value) {
    return {
      date: "-",
      time: "-",
    };
  }
  const [date, time] = value.split(separator);
  const meridiem = Number(time.split(":")[0]) < 12 ? "AM" : "PM";
  return {
    date: date.split("-").reverse().join("/"),
    time: `${time} ${meridiem}`,
  };
};

export const getGender = (value) => {
  if (!value) {
    return "-";
  } else if (value.toLowerCase() === "m" || value.toLowerCase() === "male") {
    return "Male";
  } else if (value.toLowerCase() === "f" || value.toLowerCase() === "female") {
    return "Female";
  } else {
    return "-";
  }
};

export const isObjEmpty = (obj) => {
  return Object.values(obj).every(
    (value) => value === null || value === "" || value === 0
  );
};

export const maskBankAcNum = (accountNumber) => {
  if (!accountNumber) return "-";
  return (
    accountNumber.slice(0, -4).replace(/./g, "*") + accountNumber.slice(-4)
  );
};
